<template>
    <div>
        <div class="columns is-mobile">
            <div class="column">
                <p class="title has-text-left">New Experimental Dataset</p> 
            </div>
        </div>    

        <div class="tile is-ancestor">
            <div class="tile is-12 is-horizontal is-parent">
                <div class="tile is-child box"> 
                    <div class="column">
                        <b-field class="has-text-left" label="Dataset name">
                            <b-input name="experimental_dataset_name" v-model="duplicateExperimentalDataset.name" placeholder="Experimental Dataset Name"></b-input>
                        </b-field>
                    </div>        
                </div>          
            </div>
        </div>      
        <!-- Experimental Plan -->
        <div class="tile is-ancestor">
            <div class="tile is-12 is-vertical is-parent">
                <!-- activeExperimentalPlans -->
                <div class="tile  has-text-left is-child box">     
                    <b-field label="Select an Experimental Plan">
                        <b-select v-model="duplicateExperimentalDataset.experimental_plan" placeholder="Select an Experimental Plan">
                            <option
                                v-for="plan in activeExperimentalPlans"
                                :value="plan.id"
                                :key="plan.id">
                                {{ plan.name }}
                            </option>
                        </b-select>
                    </b-field>
                    
                    <div class="columns" v-if="duplicateExperimentalDataset.experimental_plan">
                        <div class="column is-narrow">
                            <a class="has-text-link" @click="openMethodModal">
                                <span>View Analytical Method</span>
                            </a>
                        </div>  
                        <div class="column is-narrow">
                            <a class="has-text-link" @click="openTemplateModal">
                                <span>View Validation plan</span>
                            </a>
                        </div> 
                    </div> 
                </div>      
            </div>
        </div> 
        <!-- /Experimental Plan -->      

            
        <!-- Submit Form button -->
        <a class="button is-large is-primary" @click="submitNewExperimentalDataset()">
            <span>Next</span>
        </a>
        <span style="margin-left:20px"></span>
        <a class="button is-large"  @click="$router.go(-1)">
            <span>Cancel</span>
        </a>
        <!--  -->  
    </div>
    
</template>


<script>
import DisplayViewModal from "../modals/DisplayViewModal"
export default {
    name: "NewExperimentalDatasetComponent",
    props: ["activeExperimentalPlans", "duplicateExperimentalDataset"],
    components: {
        DisplayViewModal
    },
    data: function() {

        return {
        }
    },
    methods: {
        submitNewExperimentalDataset: function(){
            var newExperimentalDataset = {
                name:this.duplicateExperimentalDataset.name,
                experimental_plan: this.duplicateExperimentalDataset.experimental_plan
            }
            this.$emit("submitNewExperimentalDataset", newExperimentalDataset)
        },
        openMethodModal: function() {
            this.$modal.open({
                parent: this,
                component: DisplayViewModal,
                hasModalCard: true,
                props: {
                    currentMethod: this.activeExperimentalPlans.find(plan => plan.id==this.duplicateExperimentalDataset.experimental_plan).method
                }
            })
        },
        openTemplateModal: function() {
            this.$modal.open({
                parent: this,
                component: DisplayViewModal,
                hasModalCard: true,
                props: {
                    currentValidationPlanTemplate: this.activeExperimentalPlans.find(plan => plan.id==this.duplicateExperimentalDataset.experimental_plan).template
                }
            })
        }
    }
}
</script>
